import config from "@/App/config";
import { SecureStorage } from "./SecureStorage";

export interface Storage {
  setItem: (key: string, data: string) => void;
  getItem: (key: string) => any;
  removeItem: (key: string) => void;
  clear: () => void;
}

let usingLocalStorage = false;

export const isStorageUnencrypted = (): void => {
  usingLocalStorage = config.ENVIRONMENT === "development" || window.localStorage.getItem("jwt") !== null;
};

isStorageUnencrypted();

const getStorage = (): Storage => {
  return usingLocalStorage ? LocalStorage : EncryptedStorage;
};

export const getItemFromLocalStorage = ({ key, parse = false }: { key: string; parse?: boolean }) => {
  const value = getStorage().getItem(key);
  if (parse && value) return JSON.parse(value);
  return value;
};

export const setItemInLocalStorage = ({ key, value }: { key: string; value: any }): void => {
  let storeValue = value;
  if (typeof value === "object") storeValue = JSON.stringify(value);
  getStorage().setItem(key, storeValue);
};

export const removeItemFromLocalStorage = (key: string) => getStorage().removeItem(key);

export const clearStorage = () => {
  getStorage().clear();
};

const LocalStorage: Storage = {
  setItem: (key: string, data: string): void => {
    window.localStorage.setItem(key, data);
  },
  getItem: (key: string): any => {
    return window.localStorage.getItem(key);
  },
  removeItem: (key: string): void => {
    window.localStorage.removeItem(key);
  },
  clear: (): void => {
    window.localStorage.clear();
  },
};

const EncryptedStorage: Storage = {
  setItem: (key: string, data: string): void => {
    SecureStorage.setItem(key, data);
  },
  getItem: (key: string): any => {
    return SecureStorage.getItem(key);
  },
  removeItem: (key: string): void => {
    SecureStorage.removeItem(key);
  },
  clear: (): void => {
    SecureStorage.clear();
  },
};

export const Storage: Storage = {
  setItem: (key: string, data: string): void => {
    getStorage().setItem(key, data);
  },
  getItem: (key: string): any => {
    return getStorage().getItem(key);
  },
  removeItem: (key: string): void => {
    getStorage().removeItem(key);
  },
  clear: (): void => {
    getStorage().clear();
  },
};
